export default __webpack_public_path__ + "static/media/ag-title-en.874a708f.webp";